module.exports = __webpack_public_path__ + "static/testimonial-thumb-5-f79956c16f74306ba171f5f5f4665bbd.jpg";